import React from 'react';

import style from "./style.module.css";

const Checkbox = ({ id, name, checked = false, onClick = () => { }, label = false, disabled = false }) => {
    return (
        <label htmlFor={id} className={`${style.checkbox} ${disabled ? style.disabled : ""}`}>
            <input
                type="checkbox"
                className={style.inputCheck}
                onClick={onClick}
                checked={checked ? true : false}
                readOnly={true}
                id={id}
                disabled={disabled}
                name={name}
            />
            <span className={style.check}>
                <span className={style.checked}>
                    <i className="fa-regular fa-square-check"></i>
                </span>
                <span className={style.unchecked}>
                    <i className="fa-regular fa-square"></i>
                </span>
            </span>
            {
                label !== false && <span className={style.checkboxLabel}>{label}</span>
            }
        </label>
    )
}

export default Checkbox;